import request from '@/request'
export const saveOrder = (orderType,data) => {
    return request({
        url:'/api-gateway/service/applicationForm/'+orderType,
        method:'post',
        data,
    });
}
export const orderDetail = (orderNo) => {
    return request({
        url:`/api-gateway/service/orderPubDetail/${orderNo}`,
        method:'get'
    });
}
export const applicationConfirm = (data) => {
    return request({
        url:`/api-gateway/service/applicationConfirm`,
        method:'post',
        data
    });
}
export const serviceOrderDetail = (serviceId) => {
    return request({
        url:`/api-gateway/service/serviceOrderPubDetail/${serviceId}`,
        method:'get'
    });
}
export const serviceOrderConfirm = (data) => {
    return request({
        url:`/api-gateway/service/serviceOrderConfirm`,
        method:'post',
        data,
    });
}
export const queryServiceClientFile = (serviceId,fileType) => {
    return request({
        url:`/api-gateway/service/queryServiceClientFile/${serviceId}/${fileType}`,
        method:'post'
    });
}
export const serviceOrderSurvey = (data) => {
    return request({
        url:`/api-gateway/service/serviceOrderSurvey`,
        method:'post',
        data,
    });
}
export const traningDetail = (traningCode) => {
    return request({
        url:`/api-gateway/service/traningDetail/${traningCode}`,
        method:'get'
    });
}
export const saveTraningSurvey = (data) => {
    return request({
        url:`/api-gateway/service/saveTraningSurvey`,
        method:'post',
        data,
    });
}
export const invoiceDetail = (orderNo,clientId) => {
    return request({
        url:`/api-gateway/service/invoiceDetail/${orderNo}/${clientId}`,
        method:'get'
    });
}
export const saveInvoice = (data) => {
    return request({
        url:'/api-gateway/service/saveInvoice',
        method:'post',
        data,
    });
}